// extracted by mini-css-extract-plugin
export default {"container":"RacingResult_container__yBN6L"};